
export enum EUsersIds {
    EMPLOYEES_AND_ACCESS = 'employees-and-access',
    ROLES = 'roles',
}

export const usersPageFragments = [
    {
        title: 'SETTINGS.USERS.EMPLOYEES_AND_ACCESS',
        id: EUsersIds.EMPLOYEES_AND_ACCESS,
    },
    {
        title: 'SETTINGS.USERS.ROLES',
        id: EUsersIds.ROLES,
    },
];